module.exports = __webpack_public_path__ + "static/media/M1.476a4aa1.jpg";